'use client';

import { useMemo, useEffect, useState } from 'react';

export const useAppShell = () => {
  const [isMobile, setIsMobile] = useState(false);
  const [isDesktop, setIsDesktop] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768); // md breakpoint
      setIsDesktop(window.innerWidth >= 768);
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const layoutClasses = useMemo(
    () => ({
      'cf-page-shell': true,
      'cf-layout-mobile': isMobile,
    }),
    [isMobile]
  );

  const layoutClassesString = useMemo(
    () => Object.entries(layoutClasses).filter(([, v]) => v).map(([k]) => k).join(' '),
    [layoutClasses]
  );

  return {
    isMobile,
    isDesktop,
    layoutClasses: layoutClassesString,
  };
};

